<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex m12>
        <v-card>
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("organisations.org_active_users") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-data-table
              :headers="org_headers"
              :items="organisations"
              :items-per-page="organisations.length"
              :options.sync="org_pagination"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                'items-per-page-all-text': $t('global.items_per_page_all_text'),
                'items-per-page-text': $t('global.items_per_page_text'),
                'page-text': $t('global.page_text')
              }"
              :server-items-length="org_total"
              :loading="org_show_loading"
              :loading-text="$t('global.loading_text')"
              :no-data-text="$t('global.no_data_text')"
              :no-results-text="$t('global.no_results_text')"
              :must-sort="true"
            >
              <template v-slot:item.actions="{ item }">
                <router-link
                  :to="{
                    path: BACKEND_URL + '/organisations/edit/' + item.id,
                    props: { id: item.id }
                  }"
                  v-if="$can('organisation-edit')"
                >
                  <action-button type="edit" :icon_only="true" small />
                </router-link>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "dashboard",

  data() {
    return {
      organisations: [],
      org_total: 0,
      org_show_loading: false,
      org_show_filter: false,
      org_refresh: false,
      org_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"]
      },
      org_search_params: {
        any: ""
      }
    }
  },

  computed: {
    org_headers: {
      get() {
        return [
          { text: this.$t("organisations.name"), value: "name" },
          {
            text: this.$t("organisations.no_of_tenants"),
            value: "no_of_tenants"
          },
          {
            text: this.$t("organisations.no_of_active_users"),
            value: "no_of_active_users"
          },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    }
  },

  watch: {
    org_refresh: {
      handler() {
        if (this.org_refresh) {
          this.org_list()
        }
      }
    },
    org_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.org_refresh = true
      }
    }
  },

  methods: {
    org_list() {
      this.org_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.org_pagination
      let query = this.$queryString(this.org_pagination, this.org_search_params)

      axios.get(this.API_URL + "organisations" + "?resourcetype=organisation-tenant&" + query).then((res) => {
        this.organisations = res.data.data
        this.org_total = res.data.meta.total
        this.org_refresh = false
        this.org_show_loading = false

        this.org_pagination.page = res.data.meta.current_page
        this.org_pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    }
  }
}
</script>
